exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.matching-posts-count {\n    color: #28a745;\n    font-weight: 400;\n\tmargin-left: 1rem;\n}\n", ""]);

// exports
